import React from 'react';
import { instagramPosts } from '../mock';
import { Instagram, Heart, MessageCircle } from 'lucide-react';
import useReveal from '../hooks/useReveal';

const INSTAGRAM_URL = 'https://www.instagram.com/rajpurohitperfumes?igsh=MWpkOTQ3Mm1pcWM2bg==';

export default function InstagramSection() {
  const [ref, visible] = useReveal();
  return (
    <section ref={ref} className={`max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-24 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-3">
        {instagramPosts.map((src, i) => (
          <a key={i} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="group relative aspect-square overflow-hidden rounded-md bg-[#EFE6D6]">
            {visible ? (
              <img src={src} alt="Rajpurohit post" width={400} height={400} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[900ms]" />
            ) : null}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="absolute inset-0 flex items-end p-3 opacity-0 group-hover:opacity-100 transition-opacity">
              <div className="flex items-center gap-3 text-white text-xs">
                <span className="flex items-center gap-1"><Heart className="w-3.5 h-3.5 fill-white" /> {320 + i * 47}</span>
                <span className="flex items-center gap-1"><MessageCircle className="w-3.5 h-3.5" /> {12 + i * 3}</span>
              </div>
            </div>
            <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
              <div className="w-7 h-7 rounded-full bg-white/95 flex items-center justify-center">
                <Instagram className="w-3.5 h-3.5 text-[#1A2332]" />
              </div>
            </div>
          </a>
        ))}
      </div>
      <div className="text-center mt-10">
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm tracking-[0.2em] uppercase text-[#1A2332] hover:text-[#8a6f2d] border-b border-[#1A2332] hover:border-[#8a6f2d] pb-1 transition">
          <Instagram className="w-4 h-4" /> Follow On Instagram
        </a>
      </div>
    </section>
  );
}
